<template>
  <div class="app-content-wrapper">
    <div class="create-wrapper">
      <div>
        <el-image
          style="width: 230px; height: 180px"
          :src="require('../../../assets/images/app.png')"></el-image>
      </div>
      <div class="right-wrapper">
        <div class="title">{{$t('message.application.addAppTitle')}}</div>
        <div class="description margin-top-5">{{$t('message.application.addAppDescription')}}</div>
        <el-button
          v-if="merchantType !== 'B2B' && merchantType !== 'B2C'"
          v-permission="'application:list:add'"
          @click="addApplication"
          type="primary"
          class="margin-top-15"
          size="small">{{$t('message.application.addApp')}}</el-button>
      </div>
    </div>
    <div class="border margin-top-11 margin-bottom-19"></div>
    <div v-loading="isLoading">
      <div class="search-wrapper">
        <search-component
          ref="search"
          :search-condition="searchCondition"
          :search-buttons="searchButtonList"
          :fuzzySearchKey="'appId'"
          :fuzzySearchPlaceholder="'ID'"
          :showFilterNumber="false"
          :showMerchantSearch="true"
          @toSearch="search"
        ></search-component>
      </div>
      <div v-if="appList.content.length > 0" class="list-wrapper margin-top-20">
        <h1 class="title margin-bottom-3">{{$t('message.application.myApp')}}</h1>
        <el-collapse accordion @change="collapseChange">
          <el-collapse-item v-for="(item, index) in appList.content" :key="item.id" :name="index">
            <template slot="title">
              <div class="item-wrapper">
                <div class="left-wrapper">
                  <div class="type margin-right-15 margin-top-16">
                    <el-image class="app-icon" :src="getAppIcon(item.websiteTypeName)"></el-image>
                  </div>
                  <div class="margin-top-8">
                    <div class="content">
                      <span class="name">{{item.appName}}</span>
                      <span v-if="showMechantNo" class="id margin-left-20">{{item.merchantNo}}</span>
                      <!-- 审核通过时显示应用状态 -->
                      <span v-if="!item.auditStatus || item.auditStatus === 'pass'" class="margin-left-30 status" :class="`status${item.status}`">{{$t(getAppStatus(item.status))}}</span>
                      <span v-if="item.auditStatus" class="margin-left-30 status" :class="`status-${item.auditStatus}`">{{item.auditStatusName}}</span>
                      <!-- 审核不通过时，显示修改资料按钮 -->
                      <span
                        v-if="item.auditStatus === 'fail'"
                        class="margin-left-30 edit-btn"
                        @click="handleEdit(item.id, $event)"
                        v-permission="'application:list:edit'">{{$t('message.application.edit')}}</span>
                    </div>
                    <div>
                      <span class="id">ID: {{item.id}}</span>
                      <span v-if="item.appType !== 'B2B' && item.appType !== 'B2C'" class="website margin-left-20">{{item.website}}</span>
                      <span v-else class="margin-left-20">{{getAddressText(item)}}</span>
                    </div>
                  </div>
                </div>
                <div class="apptype">{{item.websiteTypeName}}</div>
              </div>
            </template>
            <details-component
              :row-column="2"
              :direction="'vertical'"
              :details-condition="item.condition"
              v-loading="item.loading">
              <template #cardType>
                <div style="width: 50%;" class="content-inner" :class="{'has-more': item.showMore}">
                  <div class="sub-item-content" :style="{'max-height': '28px'}">
                    <div class="sub-item-content-text" :class="index" :ref="`sub-item-content-text-${index}`">
                      {{ item.supportCard || '--'}}
                    </div>
                  </div>
                  <div class="show-more-btn" v-if="item.showMore">
                    <span class="ellipsis">......</span>
                    <el-popover
                      placement="right"
                      :width="500"
                      trigger="click">
                      <div>{{ item.supportCard }}</div>
                      <template #reference>
                        <a>{{$t('message.common.more')}}</a>
                      </template>
                    </el-popover>
                  </div>
                </div>
              </template>
            </details-component>
          </el-collapse-item>
        </el-collapse>
        <div class="rhcn-pagination">
          <el-pagination v-if="appList.totalElements && appList.totalElements!=0"
            background
            :page-sizes="[10, 20, 50]"
            :current-page="Number(appList.current)"
            :page-size="appList.size"
            :total="appList.totalElements"
            layout="total, sizes, prev, pager,jumper,next"
            :prev-text="$t('message.tableTitleCommon.previous')"
            :next-text="$t('message.tableTitleCommon.next')"
            @current-change="onCurrentPageChange"
            @size-change="onPageSizeChange"/>
        </div>
      </div>
      <div v-if="!isLoading && appList.content.length === 0" class="app-empty-box">
        <empty-component :empty-subtitle="$t('message.tableCommon.searcnEmpty')"></empty-component>
      </div>
    </div>
    <el-drawer :visible="openAppCreateModal" :modal="false" :withHeader="false" size="100%" direction="btt" custom-class="no-animation">
      <rhcn-drawer title="message.application.newWebsiteApp" description="message.application.newWebsiteAppDes" @on-close="openAppCreateModal = false">
        <div class="modal-wrapper">
          <div class="form-wrapper">
            <validation-component
              ref="appForm"
              @afterViewInit="onAfterFormInit"
              :validation-condition="addAppCondition">
            </validation-component>
            <div class="margin-top-25">
              <el-button :loading="createLoading" style="width:100%;" type="primary" @click="submitCreateApp">{{$t('message.common.submit')}}</el-button>
            </div>
          </div>
        </div>
      </rhcn-drawer>
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getDictionary } from '@/api/common';
import DetailsComponent from '@/components/base-details/details.vue';
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import EmptyComponent from '@/components/table/empty-component.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { setRequiredTip, STRING_LENGTH_256 } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import ApplicationService from '@/views/application/api/application-list.service';
import { ApplicationStatus } from '@/views/application/status/application';
import { AppIcons } from '@/views/application/tools/application';

export default {
  components: {
    RhcnDrawer,
    SearchComponent,
    ValidationComponent,
    EmptyComponent,
    DetailsComponent,
  },
  data() {
    return {
      ...ApplicationService,
      searchKey: '',
      isLoading: true,
      appList: {
        totalElements: 0,
        size: 10,
        current: 1,
        content: {},
      },
      openAppCreateModal: false,
      createLoading: false,
      appTypeList: [],
      addAppCondition: [
        {
          key: 'appName',
          name: 'message.tableCommon.appName',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [setRequiredTip('message.application.appNameTip'), STRING_LENGTH_256],
          placeholder: 'message.application.appNameTip',
        },
        {
          key: 'appType',
          name: 'message.tableCommon.appType',
          type: 'select',
          defValue: '',
          isShowStar: true,
          rule: [setRequiredTip('message.application.appTypeTip')],
          options: this.appTypeList,
          placeholder: 'message.application.appTypeTip',
          withIcon: true,
        },
        {
          key: 'website',
          name: 'message.tableCommon.appWebsite',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [setRequiredTip('message.application.appWebsiteTip'), STRING_LENGTH_256],
          placeholder: 'message.application.appWebsiteTip',
        },
      ],
      merchantType: 'COMMON',
      searchCondition: [
        {
          key: 'appName',
          name: 'message.tableCommon.appName',
          type: 'input',
        },
        {
          key: 'status',
          name: 'message.tableCommon.status',
          type: 'select',
          options: [], // [初始化、启用、停用]
        },
      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'application:list:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await ApplicationService.downloadApplicationList(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        }],
      showMechantNo: false,
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    const userLogin = this.app.userLogin;
    if (userLogin && userLogin.businessType === '0') {
      this.merchantType = 'B2B';
    } else if (userLogin && userLogin.businessType === '2') {
      this.merchantType = 'B2C';
    }
    if (userLogin && `${userLogin.merchantType}` === '3') {
      this.showMechantNo = true;
    }
    // this.initQuery();
    const params = this.$route.query;
    this.search({
      ...params,
    });
    getDictionary(['WEB_TYPE', 'APP_STATUS']).then((res) => {
      const webTypeArr = [];
      if (res.WEB_TYPE && res.WEB_TYPE) {
        res.WEB_TYPE.forEach((item) => {
          webTypeArr.push({
            label: item.description,
            text: item.description,
            value: item.value,
            icon: this.getAppIcon(item.description),
          });
        });
      }
      if (res.APP_STATUS) {
        const appStatusList = [];
        res.APP_STATUS.forEach((item) => {
          if (item.value !== '4') { // 废弃状态不显示
            appStatusList.push({
              label: item.description,
              value: item.value,
            });
          }
        });
        this.$refs.search.setSearchSelectOptions('status', appStatusList);
      }
      this.appTypeList = webTypeArr;
    }).catch(() => {
    });
  },
  methods: {
    search(params = {}) {
      this.appList.current = 1;
      this.getAppList(this.appList.current, this.appList.size, { ...params });
    },
    getAppList(current, size, params) {
      this.isLoading = true;
      let p = params;
      if (!p) {
        p = this.$refs.search.getSearchJson();
      }
      const query = {
        ...p,
      };
      this.$router.push({
        query: { ...query },
      });
      ApplicationService.getApplicationList({
        ...query,
        current: this.appList.current,
        size: this.appList.size,
      }).then(res => {
        res.content = (res.content || []).map(item => ({
          ...item,
          loading: false,
          supportCard: '',
          condition: [{
            type: 'default',
            initRows: 10,
            listTemplate: [
              {
                titleBar: { title: 'message.application.createTime' },
                key: 'createTime',
              },
              {
                titleBar: { title: 'message.application.id' },
                key: 'id',
              },
              {
                titleBar: { title: 'message.application.websiteType' },
                key: 'websiteTypeName',
              },
              {
                titleBar: { title: 'message.application.merchantName' },
                key: 'appName',
              },
              {
                titleBar: { title: 'message.application.storeUrl' },
                key: 'shopOriginWebsite',
              },
              {
                titleBar: { title: 'message.application.auditStatus' },
                key: 'auditStatusName',
              },
              {
                titleBar: { title: 'message.tableCommon.cardType' },
                key: 'cardType',
                type: 'slot',
              },
            ],
            data: item,
          }],
        }));
        this.appList = res;
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    getAppStatus(status) {
      return getEnantiomericValue(ApplicationStatus, status);
    },
    onCurrentPageChange(index) {
      this.appList.current = index;
      this.getAppList(index);
    },
    onPageSizeChange(size) {
      this.appList.size = size;
      this.appList.current = 1;
      this.getAppList(1, size);
    },
    initSelectedDictionaries() {
      this.$refs.validationModal.getForm().setValidationSelectOptions('appType', this.appTypeList);
    },
    addApplication() {
      this.openAppCreateModal = true;
    },
    submitCreateApp() {
      this.$refs.appForm.toFormValid(this.createAppHttpRequest);
    },
    createAppHttpRequest() {
      this.createLoading = true;
      this.postAddApplication(this.$refs.appForm.getFormJson()).then((res) => {
        this.createLoading = false;
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        this.openAppCreateModal = false;
        this.getAppList();
      }).catch(() => {
        this.createLoading = false;
      });
    },
    onAfterFormInit() {
      this.$refs.appForm.setValidationSelectOptions('appType', this.appTypeList);
    },
    initQuery() {
      const query = this.$route.query;
      if (query.searchKey) {
        this.searchKey = query.searchKey;
      }
      if (query.current) {
        this.appList.current = Number(query.current);
      }
      if (query.size) {
        this.appList.size = Number(query.size);
      }
    },
    getAppIcon(websiteTypeName) {
      if (AppIcons.indexOf(websiteTypeName) > -1) {
        return require(`@/assets/images/appicon/${websiteTypeName}.png`);
      }
      return require('@/assets/images/appicon/default.png');
    },
    getAddressText(app) {
      const arr = [];
      if (app.street) {
        arr.push(app.street);
      }
      if (app.city) {
        arr.push(app.city);
      }
      if (app.country) {
        arr.push(app.country);
      }
      return arr.join(';');
    },
    handleEdit(appId, event) {
      event.stopPropagation();
      this.$router.push({ path: '/collection/virtual-account/add', query: { appId } });
    },
    async collapseChange(value) {
      if (typeof value !== 'number') {
        return;
      }
      try {
        if (!this.appList.content[value].supportCard) {
          this.appList.content[value].loading = true;
          const supportCards = await ApplicationService.getSupoortCards(this.appList.content[value].id);
          let cardStr = '';
          supportCards.forEach((item) => {
            if (cardStr) {
              cardStr = `${cardStr}, ${item.cardTypeName}`;
            } else {
              cardStr = item.cardTypeName;
            }
          });
          this.appList.content[value].supportCard = cardStr;
          this.appList.content[value].loading = false;
        }
      } catch (error) {
        this.appList.content[value].loading = false;
        console.log('Get support cards error', error);
      }
      this.$nextTick(() => {
        if (this.appList.content[value].showMore) {
          return;
        }
        const ref = this.$refs[`sub-item-content-text-${value}`];
        if (ref) {
          const height = ref[0].offsetHeight;
          if (height > 28) {
            this.appList.content[value].showMore = true;
            this.$forceUpdate();
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/pagination.scss';
.app-content-wrapper {
  color: $color-text-primary;
  .create-wrapper {
    display: flex;
    align-items: center;
    .right-wrapper {
      padding-left: 10px;
      .title {
        font-size: 16px;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 28px;
      }
      .description {
        font-size: 14px;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 21px;
      }
    }
  }
  .border {
    border-top: 1px solid rgba(0,32,63,0.08);
    width: 100%;
  }
  .search-input-wrapper {
    width: 275px;
    max-width: 100%;
  }
  .list-wrapper {

    .title {
      font-size: 14px;
      font-weight: 800;
      line-height: 36px;
    }
    .item-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 0 16px;
      border-radius: 4px;
      margin-bottom: 5px;
      line-height: 36px;
      &:hover {
        .type {
          background-color: $color-white;
        }
      }
      .type {
        background: $color-default;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        transition: background-color 0.5s;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .left-wrapper {
        display: flex;
        align-items: flex-start;
        height: 100%;
        .app-icon {
          white-space: nowrap;
          display: flex;
          width: 24px;
        }
        .name {
          font-size: 14px;
          font-weight: 800;
          line-height: 36px;
        }
        .status {
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          font-weight: 800;
          border-radius: 10px;
          padding: 0 10px;
          display: inline-block;
          &.status2, &.status-fail {
            color: $color-danger;
          }
          &.status1 {
            color: $color-text-default-button;
          }
        }

        .edit-btn {
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          font-weight: 800;
          border-radius: 10px;
          padding: 0 10px;
          display: inline-block;
          color: white;
          background-color: $color-text-default-button;
          cursor: pointer;
        }

        .id {
          font-size: 14px;
          line-height: 21px;
        }
        .website {
          font-size: 14px;
          line-height: 21px;
          color: $color-text-default-button;
        }
      }
      .apptype {
        font-size: 14px;
        font-weight: 800;
      }
    }
  }
}
.modal-wrapper {
  .form-wrapper {
    width: 409px;
    margin: 23px auto 0;
  }
}
</style>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.app-empty-box {
  margin-top: 80px;
}

.list-wrapper {
  ::v-deep .el-collapse {
    border-bottom: none;
    border-top: none;
  }
  ::v-deep .el-collapse-item__header {
    min-height: 80px;
    border-bottom: none;
    padding-left: 11px;
    padding-right: 20px;

    &:hover {
      background: $color-default;
    }
  }

  ::v-deep .el-collapse-item.is-active {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    margin-bottom: 25px;
  }

  ::v-deep .el-collapse-item__content {
    margin-left: 76px;
    margin-right: 20px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  ::v-deep #details .bd-details-wrap:last-child {
    border-bottom: none;
  }

  ::v-deep #details .el-descriptions-item__label {
    color: $color-text-primary;
  }

  ::v-deep .el-collapse-item__arrow.el-icon-arrow-right:before {
    font-family: "iconfont" !important;
    content: "\e672";
    color: #0098C7;
  }
}
</style>
